// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"file-excel"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 22H20V8H14V2H4V22Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M14 2V8H20M14 2H15L20 7V8M14 2H4V22H20V8","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M14 11L14 11.6465C14 11.918 13.8896 12.1779 13.6941 12.3664L12 14M10 11L10 11.6465C10 11.918 10.1104 12.1779 10.3059 12.3664L12 14M12 14L10.3059 15.6336C10.1104 15.8221 10 16.082 10 16.3535L10 17M12 14L13.6941 15.6336C13.8896 15.8221 14 16.082 14 16.3535V17","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-file-excel')
export default class FileExcelIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'file-excel',
    }
  }
}
